module.exports = __webpack_public_path__ + "media/images/errors/ufo-7b2e7afce7cc36fde2409f399154da72.png";